import React, { useState, useEffect } from "react";
import { Col, Row } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { reduxForm } from "redux-form";

import CardContainer from "../../commons/components/cardContainer"
import PasswordForm from "./passwordForm";
import EmailForm from "./emailForm";
import AccountRow from "./accountRow";
import EmailSecundarioForm from "./emailSecundarioForm"
import Message from '../../commons/utils/message'
import Http from "../../commons/utils/Http";
import {initPasswordForm} from "../../store/actions/securityAndLoginAction";
import Utils from "../../commons/utils/utils";

function SegurancaForm(props) {
    const { handleSubmit } = props;
    const { userData } = useSelector(state => state.userLogin);
    const [editing, setEditing] = useState(props.edit_form ? props.edit_form : false);

    //erros
    const [hasErrorCurrentPassword, setHasErrorCurrentPassword] = useState(false);
    const [errorMsgCurrentPassword, setErrorMsgCurrentPassword] = useState(false);

    const [hasErrorNewPassword, setHasErrorNewPassword] = useState(false);
    const [errorMsgNewPassword, setErrorMsgNewPassword] = useState(false);

    const [hasErrorConfirmPassword, setHasErrorConfirmPassword] = useState(false);
    const [errorMsgConfirmPassword, setErrorMsgConfirmPassword] = useState(false);

    const [passwordParameter, setPasswordParameter] = useState("");

    useEffect(() => {
        if(userData.id){
            Http.get(`/get-password-parameters?userid=${userData.id}`, Utils.headers)
                    .then(response => {
                        setPasswordParameter(response);
    
                        
                    }).catch(err => {
                        console.log(err)
                })
        }
    }, [userData]);

    const dispatch = useDispatch();

    function validateChangePassword(data) {
        let valid = true;
        if (!data.password) {
            setHasErrorCurrentPassword(true);
            setErrorMsgCurrentPassword("Informe a senha cadastrada");
            valid = false;
        } else {
            if (data.password.length < 1) {
                setHasErrorCurrentPassword(true);
                setErrorMsgCurrentPassword("Informe a senha cadastrada");
                valid = false;
            }

        }
        if (data.new_password == undefined) {
            setHasErrorNewPassword(true);
            setErrorMsgNewPassword("Informe a nova cadastrada");
            valid = false;

        } else {
            if (data.new_password.length < 1 || data.new_password.includes(" ")) {
                setHasErrorNewPassword(true);
                setErrorMsgNewPassword("Sua senha não pode possuir espaços");
                valid = false;
            }
        }

        if (data.new_password == undefined) {
            setErrorMsgNewPassword(true);
            setErrorMsgNewPassword("Informe a nova senha");
            valid = false;
        } else if (data.confirm_password == undefined) {
            setHasErrorConfirmPassword(true);
            setErrorMsgConfirmPassword("Informe a nova senha");
            valid = false;
        } else {
            if ((data.new_password !== "" && data.confirm_password !== "") && (data.new_password !== data.confirm_password)) {
                setHasErrorConfirmPassword(true);
                setErrorMsgConfirmPassword("As senhas informadas são diferentes");
                valid = false;
            }
        }
        return valid;
    }

    function cleanFormErrors() {
        setHasErrorCurrentPassword(false);
        setHasErrorNewPassword(false);
        setHasErrorConfirmPassword(false);
    }

    function initUserForm() {
        dispatch(initPasswordForm())
        setEditing(!editing);
        cleanFormErrors();
    }

    function handleDispatch(values) {
        if (validateChangePassword(values)) {
            values["id"] = userData.id;
            savePasswordData(values);
        }
    }

    async function savePasswordData(data) {
        Http.put('/users/change-password', data, Http.headers)
            .then(response => {
                const responseData = response.data.response
                if (!responseData.error) {
                    Message.showSuccess(responseData.message);
                    setEditing(!editing);
                }
            }).catch(err => {
                const code = err.response.data.response.status;
                
                if (code == "401") {
                    setHasErrorCurrentPassword(true);
                    setErrorMsgCurrentPassword(err.response.data.response.message);

                    return;
                }

                if (code == "410") {
                    setHasErrorNewPassword(true);
                    setErrorMsgNewPassword(err.response.data.response.message);

                    return;
                }

                Message.showError(err.response.data.response.message);
            })
    };

    function renderEditButton() {
        if (editing) {
            return (
                <>
                    <a style={{ marginRight: 24 }} onClick={() => setEditing(!editing)}
                        className={"account-link"}>Cancelar
                    </a>
                    <button type="submit" className={"account-button account-button-primary"}>Salvar alterações</button>
                </>
            )
        } else {
            return (
                <button onClick={initUserForm} className={"account-button account-button-default"}>
                    Editar segurança e login
                </button>
            )
        }
    }

    function renderSecurityContainer() {
        if (userData.id) {
            return (
                <form onSubmit={(handleSubmit(values => handleDispatch(values)))}>
                    <Row style={{
                        display: "flex",
                        alignItems: "center",
                    }}>
                        <Col span={12}>
                            <h2 className={"dados-header"}>Segurança e login</h2>
                            <span className={"dados-header-subtitle"}>Seus dados de acesso e recuperação.</span>
                        </Col>

                        <Col span={12}>
                            <div style={{ textAlign: "end" }}>
                                {renderEditButton()}
                            </div>
                        </Col>
                    </Row>

                    <CardContainer>
                        <AccountRow>
                            <Col span={4}>
                                <span className={"account-card-label"}>Senha:</span>
                            </Col>

                            <PasswordForm
                                editing={editing}
                                hasErrorCurrentPassword={hasErrorCurrentPassword}
                                errorMsgCurrentPassword={errorMsgCurrentPassword}
                                hasErrorNewPassword={hasErrorNewPassword}
                                errorMsgNewPassword={errorMsgNewPassword}
                                hasErrorConfirmPassword={hasErrorConfirmPassword}
                                errorMsgConfirmPassword={errorMsgConfirmPassword}
                                onChangeCurrentPassword={() => setHasErrorCurrentPassword(false)}
                                onChangeNewPassword={() => setHasErrorNewPassword(false)}
                                onChangeConfirmPassword={() => setHasErrorConfirmPassword(false)} 
                                passwordParameters={passwordParameter}
                                />
                        </AccountRow>

                        <AccountRow>
                            <Col span={4}>
                                <span className={"account-card-label"}>E-mail principal:</span>
                            </Col>

                            <EmailForm editing={editing} email={userData.email} user_id={userData.id} />
                        </AccountRow>

                        <AccountRow noBorder>
                            <Col span={4} >
                                <span className={"account-card-label"}>E-mail de recuperação:</span>
                            </Col>

                            <EmailSecundarioForm editing={editing} />
                        </AccountRow>
                    </CardContainer>
                </form>
            )
        }else return null;
    }

    return (
        <>
            {renderSecurityContainer()}
        </>
    )
}

export default reduxForm({ form: 'editPassword' })(SegurancaForm);
